// src/components/pages/portfolios/partials/PortfolioDetaiNoDataView.js

import React from 'react';
import { Trans } from 'react-i18next';
import styles from './../style/PortfolioDetail.module.css';

export default function PortfolioDetailNoDataView({ t }) {
  return (
    <div className={styles.noDataMessage}>
      <div className={styles.portfolioInfoBox}>
        <div className={styles.iconSection}>
          <div className={styles.infoIcon}>💡</div>
          <h4>{t('portfolioDetail.noData.title')}</h4>
        </div>
        <p className={styles.mainMessage}>
          <Trans i18nKey="portfolioDetail.noData.mainMessage" components={{ 1: <span className={styles.highlight} /> }} />
        </p>
        <ul className={styles.detailList}>
          <li>
            <span className={styles.label}>{t('portfolioDetail.noData.calculationBasis')}</span>
            <span className={styles.value}>{t('portfolioDetail.noData.adjustedClosingPrice')}</span>
          </li>
          <li>
            <span className={styles.label}>{t('portfolioDetail.noData.dataUpdate')}</span>
            <span className={styles.value}>{t('portfolioDetail.noData.dailyUpdateTime')}</span>
          </li>
        </ul>
        <div className={styles.examplesSection}>
          <div className={styles.exampleItem}>
            <span className={styles.exampleTitle}>{t('portfolioDetail.noData.tradingDayTitle')}</span>
            <p>
              <Trans i18nKey="portfolioDetail.noData.tradingDayExample" components={{ 1: <span className={styles.bold} /> }} />
              <br /><span className={styles.explanation}>{t('portfolioDetail.noData.tradingDayExplanation')}</span>
            </p>
          </div>
          <div className={styles.exampleItem}>
            <span className={styles.exampleTitle}>{t('portfolioDetail.noData.nonTradingDayTitle')}</span>
            <p>
              <Trans i18nKey="portfolioDetail.noData.nonTradingDayExample" components={{ 1: <span className={styles.bold} /> }} />
              <br /><span className={styles.explanation}>{t('portfolioDetail.noData.nonTradingDayExplanation')}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}